import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { ReactComponent as CloseIcon } from '../../../assets/icons/close-circle.svg';
import { ReactComponent as NavigateArrow } from '../../../assets/icons/device-management/navigate-back.svg';
import { AvailableTabProperties } from '../../../interface/device-management.interface';

interface DeviceManagementTabsProperties {
  containerTabs: AvailableTabProperties[];
  handleSwitchTab: (key: string) => void;
  deviceId?: string;
}

/**
 * Component to display the device management tabs
 * @param properties
 * @returns
 */
function DeviceManagementTabs(properties: DeviceManagementTabsProperties) {
  const { t, i18n } = useTranslation('devices');
  const navigate = useNavigate();
  const { containerTabs, handleSwitchTab } = properties;
  const location = useLocation();
  const { pathname } = useLocation();
  const isExpanded = pathname.includes('device-expanded');
  const basePath = isExpanded ? 'device-expanded' : 'device';
  /**
   * Go back
   */
  const handleBack = () => {
    const updated = location.pathname.replace(new RegExp(`/${basePath}/[^/]+/[^/]+$`), '');
    navigate(updated);
  };

  return (
    <div className="container-tabs-wrap" dir={i18n.dir()}>
      <div className="navigate-arrow">
        <span
          role="presentation"
          onClick={handleBack}
          style={{ transform: i18n.dir() === 'rtl' ? 'rotate(180deg)' : 'none' }}>
          <NavigateArrow />
        </span>
        <div className="navigate-background" />
      </div>
      <div className="title">
        <h1>{t('deviceManagement')}</h1>
      </div>
      <div className="tabs-container">
        {containerTabs.map((tab) => (
          <div
            key={tab.key}
            className={`each-tab ${tab.isActive ? 'active' : ''}`}
            role="presentation"
            onClick={() => handleSwitchTab(tab.key)}>
            <span>{tab.label}</span>
          </div>
        ))}
      </div>
      <div className="close-icon">
        <span role="presentation" onClick={handleBack}>
          <CloseIcon />
        </span>
      </div>
    </div>
  );
}

export default DeviceManagementTabs;
